var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "../ui/Button";
import { LoadingSpinner } from "../ui/LoadingSpinner";
export function ButtonFormSubmit(_a) {
    var loading = _a.loading, disabled = _a.disabled;
    return (_jsx(Button, __assign({ type: "submit", className: "self-end w-full", disabled: disabled }, { children: loading ? _jsx(LoadingSpinner, {}) : "Avançar" })));
}
